import api from '@/factories/api';

export default {
  namespaced: true,

  state: {
    loading: false,
    response: null,
  },

  mutations: {
    setLoading: (state, loading) => {
      state.loading = loading;
    },
  },

  actions: {
    async sendRequestToBot({ commit, dispatch }, data) {
      const { params, path } = data;
      const hasPrompt = data.params?.prompt;
      const method = hasPrompt ? 'post' : 'get';
      const payload = hasPrompt ? params : { params };
      commit('setLoading', true);

      try {
        const res = await api()[method](`cybot/${path}`, payload);
        return Array.isArray(res) ? res[0] : res;
      } finally {
        commit('setLoading', false);
      }
    },
  },
};
